// extracted by mini-css-extract-plugin
module.exports = {"note":"_326H7","blue":"_2v5Lm","turquoise":"Dr9ba"};